/**
 * When display_mode is "monthly_average", divides the value by 12
 * and rounds to the nearest integer. Otherwise returns the raw value.
 */
export function applyDisplayMode(
  value: number,
  displayMode?: string | null
): number {
  if (displayMode === 'monthly_average') {
    return Math.round(value / 12);
  }
  return value;
}

/**
 * When capture_rate is set, multiplies the value by the rate
 * and rounds to the nearest integer. Otherwise returns the raw value.
 * Mutually exclusive with display_mode — a widget never has both.
 */
export function applyCaptureRate(
  value: number,
  captureRate?: number | null
): number {
  if (captureRate != null) {
    return Math.round(value * captureRate);
  }
  return value;
}

type VolumeLike =
  | { claims?: number | string; encounters?: number | string }
  | null
  | undefined;

/**
 * Returns the claims-role value from a provider-volume response, substituting the
 * encounters value for cohort (encounter) slots when the show-encounters-totals flag
 * is on. Non-cohort slots and flag-off always return claims. Lets volume widgets
 * surface encounters under the existing "Claims" label without changing labels.
 */
export function claimsOrEncounters(
  data: VolumeLike,
  isCohort: boolean,
  showEncountersTotals: boolean
): number | string | undefined {
  if (showEncountersTotals && isCohort) {
    return data?.encounters ?? data?.claims;
  }
  return data?.claims;
}
